import React, { useEffect, useState } from "react";
import Select, { components } from "react-select";
import search from "../Assets/rider/search.svg";
import { useNavigate, useSearchParams } from "react-router-dom";
import "../Style/Pages/Approval.css";
import Approvalcard from "../Component/Approvalcard";
import { getWithTokenAPI } from "../Util/Api";
import { useSelector } from "react-redux";
import { CardSkeleton, UserCardSkeleton } from "../Component/Skeleton";
import { FcApproval } from "react-icons/fc";
import { toast } from "react-toastify";
const Approval = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const sortByFromUrl = searchParams.get("sortBy") || "";
  const districtFromUrl = searchParams.get("district") || "";
  const [tpage, setTpage] = useState(null);
  const [page, setPage] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [status, setStatus] = useState(sortByFromUrl);
  const auth = useSelector((state) => state.auth);
  const token = auth.token;
  const [reload, setReload] = useState(0);
  const shortbyoptions = [
    { value: "newest", label: "Newest" },
    { value: "oldest", label: "Oldest" },
  ];
  const [approvallist, setApprovallist] = useState([]);
  const [loading, setLoading] = useState(false);
  const [district, setDistrict] = useState({ label: districtFromUrl || "All", value: districtFromUrl });
  const [districtOptions, setDistrictOptions] = useState([]);

  useEffect(() => {
    setStatus(sortByFromUrl);
    setDistrict({ label: districtFromUrl || "All", value: districtFromUrl });
  }, [sortByFromUrl, districtFromUrl]);
  const [allCitiesData, setAllCitiesData] = useState([]);
  useEffect(() => {
    const fetchDistricts = async () => {
      try {
        const response = await getWithTokenAPI(token, `/admin/city/list-all`);

        const cities = response?.data?.data || [];

        setAllCitiesData(cities);

        // 🔹 Get unique districts
        const uniqueDistricts = [
          ...new Set(cities.map((item) => item.district)),
        ];

        const formattedDistricts = uniqueDistricts.map((d) => ({
          value: d,
          label: d,
        }));

        setDistrictOptions(formattedDistricts);
      } catch (err) {
        console.log(err);
      }
    };

    if (token) {
      fetchDistricts();
    }
  }, [token]);

  useEffect(() => {
    const fetchapprovallist = async () => {
      try {
        setLoading(true);

        const invalidParams = Array.from(searchParams.keys()).some(
          (key) => key !== "sortBy" && key !== "district"
        );

        if (invalidParams) {
          setApprovallist([]);
          setTpage(0);
          toast.error("Invalid URL Parameters Detected");
          return;
        }
        const response = await getWithTokenAPI(
          token,
          `/user/getall?search=${searchText}&city=${district.value}&sortBy=${status}&limit=12&page=${page}&roletype=driver&is_driver_form=Pending`,
        );
        setApprovallist(response?.data?.data);
        setTpage(response?.data?.totalpage);
        setPage(response?.data?.page);
      } catch {
        console.log("Error in fetching Limit Api");
      } finally {
        setLoading(false);
      }
    };
    fetchapprovallist();
  }, [token, searchText, status, page, district, reload]);

  const SingleValueWithLabel = (label) => (props) => (
    <components.SingleValue {...props}>
      <span className="filter-prefix">{label} :</span>
      <span className="filter-value">{props.data.label}</span>
    </components.SingleValue>
  );

  const PlaceholderWithLabel = (label) => (props) => (
    <components.Placeholder {...props}>
      <span className="filter-prefix">{label} :</span>
      <span className="filter-placeholder">All</span>
    </components.Placeholder>
  );
  const customStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: "36px",
      height: "36px",
      // width: "180px",
      minWidth: "fitContent",
      maxWidth: "180px",
      border: "none",
      borderRadius: "14px",
      boxShadow: state.isFocused ? "0 0 0 2px rgba(1,58,40,0.15)" : "none",
      backgroundColor: "white",
      cursor: "pointer",
    }),

    valueContainer: (base) => ({
      ...base,
      // padding: "0 8px",
      height: "36px",
    }),

    singleValue: (base) => ({
      ...base,
      color: "#555",
      fontSize: "14px",
      fontWeight: "500",
      margin: 0,
      lineHeight: "36px",
      top: "0",
      transform: "none",
    }),

    placeholder: (base) => ({
      ...base,
      color: "#888",
      fontSize: "14px",
      fontWeight: "500",
    }),

    dropdownIndicator: (base) => ({
      ...base,
      color: "#666",
      padding: "5px",
      "&:hover": {
        color: "#333",
      },
    }),

    indicatorSeparator: () => ({
      display: "none",
    }),

    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? "#013A28"
        : state.isFocused
          ? "#02543a53"
          : "white",
      color: state.isSelected ? "white" : "#333",
      cursor: "pointer",
      ":hover": {
        backgroundColor: state.isSelected ? "#013A28" : "#02543a53",
      },
    }),

    menu: (base) => ({
      ...base,
      borderRadius: "8px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
      zIndex: "9999",
    }),

    menuList: (base) => ({
      ...base,
      padding: 0,
      maxHeight: "180px",
      overflowY: "auto",
      zIndex: "99",

      "&::-webkit-scrollbar": {
        width: "6px",
      },
      "&::-webkit-scrollbar-track": {
        background: "#013a2826",
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#013a2855",
        borderRadius: "3px",
      },
    }),
  };
  return (
    <div className="approval">
      <div className="approvalpagehead">
        <span className="head">Approval List</span>
        <div className="approvaltopfilter">
          <div className="searchbar">
            <img src={search} alt="search" />
            <input
              className="searchinput"
              type="text"
              placeholder="Search"
              value={searchText}
              onChange={(e) => {
                setSearchText(e.target.value);
                setPage(1);
              }}
            />
          </div>
          <div className="filter-select">
            <Select
              options={districtOptions}
              value={district}
              onChange={(selected) => {
                const newDistrict = selected?.value || "";
                setDistrict(selected || { label: "All", value: "" });
                setPage(1);
                const currentParams = Object.fromEntries([...searchParams]);
                if (newDistrict) {
                  setSearchParams({ ...currentParams, district: newDistrict });
                } else {
                  const { district, ...rest } = currentParams;
                  setSearchParams(rest);
                }
              }}
              styles={customStyles}
              isSearchable={false}
              isClearable={true}
              placeholder=""
              components={{
                SingleValue: SingleValueWithLabel("District"),
                Placeholder: PlaceholderWithLabel("District"),
                IndicatorSeparator: null,
              }}
            />
            <Select
              value={status.label}
              options={shortbyoptions}
              styles={customStyles}
              onChange={(selected) => {
                const newSortBy = selected.value;
                setStatus(newSortBy);
                setPage(1);
                const currentParams = Object.fromEntries([...searchParams]);
                if (newSortBy) {
                  setSearchParams({ ...currentParams, sortBy: newSortBy });
                } else {
                  const { sortBy, ...rest } = currentParams;
                  setSearchParams(rest);
                }
              }}
              isSearchable={false}
              menuPlacement="bottom"
              menuPortalTarget={document.body}
              menuPosition="fixed"
              components={{
                SingleValue: SingleValueWithLabel("Sort by"),
                Placeholder: PlaceholderWithLabel("Sort by"),
                IndicatorSeparator: null,
              }}
              classNamePrefix="react-select"
            />
          </div>
        </div>
      </div>
      {loading ? (
        <UserCardSkeleton />
      ) : (
        <div className="approvalpagebody">
          {approvallist.length > 0 ? (
            <>
              {approvallist.map((item) => (
                <Approvalcard
                  key={item.id}
                  card={item}
                  onApproveSuccess={() => setReload((p) => p + 1)}
                />
              ))}
              {tpage > 1 && (
                <div className="pagination pagination-bottom-right">
                  {page > 1 && (
                    <button
                      className="page-btn"
                      onClick={() => setPage((page) => page - 1)}
                    >
                      ‹
                    </button>
                  )}
                  {page > 1 && (
                    <button className="page-btn" onClick={() => setPage(1)}>
                      1
                    </button>
                  )}
                  {page === tpage && <span className="page-dots">…</span>}
                  <button className="page-btn pgnoactive">{page}</button>

                  {page !== tpage && <span className="page-dots">…</span>}

                  {page !== tpage && (
                    <button className="page-btn" onClick={() => setPage(tpage)}>
                      {tpage}
                    </button>
                  )}

                  {page < tpage && (
                    <button
                      className="page-btn"
                      onClick={() => setPage((page) => page + 1)}
                    >
                      ›
                    </button>
                  )}
                </div>
              )}
            </>
          ) : (
            <div
              className="defaul"
              style={{ width: "100%", marginLeft: "350px" }}
            >
              <FcApproval style={{ fontSize: "100px", color: "#e85c5c" }} />
              <h3>No Pending Approval</h3>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Approval;
